import React from "react";
import ControlDetailsBiolyt from "./ControlDetailsBiolyt";
import ControlDetailsComfoair350 from "./ControlDetailsComfoair350";
import ControlDetailsMieleDevice from "./ControlDetailsMieleDevice";
import ControlDetailsBoschDevice from "./ControlDetailsBoschDevice";
import ControlDetailsPhotoVoltaic from "./ControlDetailsPhotoVoltaic";
import ControlDetailsClimate from "./ControlDetailsClimate";
import ControlDetailsSound from "./ControlDetailsSound";
import ControlDetailsLedStripe from "./ControlDetailsLedStripe";
import { IControl } from "../types";

interface IControlDetailsProps {
  control: IControl;
}

const ControlDetails = (props: IControlDetailsProps) => {
  const { control } = props;
  if (control.control_type === "BIOLYT") {
    return <ControlDetailsBiolyt control={control} />;
  } else if (control.control_type === "COMFOAIR350") {
    return <ControlDetailsComfoair350 control={control} />;
  } else if (control.control_type === "MIELE_DEVICE") {
    return <ControlDetailsMieleDevice control={control} />;
  } else if (control.control_type === "BOSCH_DEVICE") {
    return <ControlDetailsBoschDevice control={control} />;
  } else if (control.control_type === "PHOTO_VOLTAIC") {
    return <ControlDetailsPhotoVoltaic control={control} />;
  } else if (control.control_type === "CLIMATE") {
    return <ControlDetailsClimate control={control} />;
  } else if (control.control_type === "SOUND") {
    return <ControlDetailsSound control={control} />;
  } else if (control.control_type === "LED_STRIPE") {
    return <ControlDetailsLedStripe control={control} />;
  } else {
    return <h3>UNKNOWN</h3>;
  }
};

export default ControlDetails;
